import { panel } from "../UI/tokens";
import styled from "styled-components";

export const SSpinnerOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
`;

export const SSpinnerloading = styled.div`
${panel}
 text-align: center; padding: 28px 32px;
`;